import React 
, { useEffect, useState } 
from "react";
import PropTypes from 'prop-types';
import { 
  useDispatch, 
  useSelector } from "react-redux";
import UserProfileDropdown from "../user-profile-dropdown/UserProfileDropdown";
import MobileHeader from "./MobileHeader";
import NavItemLink from "./NavItemLink";
import NotificationDropdown from "../notification-dropdown/NotificationDropdown";
import greyCalendarHeader from "../../../assets/img/svg/grey-calendar-header.svg";
import calendarBlue from "../../../assets/img/svg/calendar-blue.svg";
import { Link, useLocation } from "react-router-dom";
import generalRoutes from "../../../Views/Pages/routes/routesConfig/index";
import SearchInput from "./SearchInput";
import LanguageSwitcher from "../../translater/LanguageSwitcher";
import translation from "../../../utils/translation";
import { getCurrentUser } from "../../../services/commonService";
import {
  fetchTotalUnreadMessageCount
} from '../../../redux/Slices/chat/ChatSlice';
import { fetchNotificationUnreadCount } from "../../../redux/Slices/common/CommonSlice";
const TopBar = ({ logOut }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const currentUser = getCurrentUser()?.data;
  const [initState, setInitState] = useState(false);
  const isMyCalendarPage = location.pathname === '/my-calendar';
  const { totalUnreadMessageCount, notificationUnreadCount } = useSelector((state) => ({
    totalUnreadMessageCount: state.chat.totalUnreadMessageCount,
    notificationUnreadCount: state.common.notificationUnreadCount,
  }))
  useEffect(() => {
    if (!initState) {
      dispatch(fetchTotalUnreadMessageCount());
      dispatch(fetchNotificationUnreadCount());
      setInitState(true);
    }
  }, [dispatch])

  const getStaffType = () => {
    if (currentUser?.staff?.id === 1) {
      return 'Admin';
    }
    return currentUser?.staff?.staff_type.charAt(0).toUpperCase() + currentUser?.staff?.staff_type.slice(1);
  }
  return (
    <div className="topBar d-flex align-items-center">
      <div className="container-fluid">
        <nav className="navbar navbar-expand-sm px-0">
          <MobileHeader />
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <div className="mw870 w-100 mr-3">
              <SearchInput placeholder={ translation('key_worker_code_hkid_english_name_chinese_name_job_offer_no_contract_ref_invoice_no_phone_email_passport') } />
            </div>
            <ul className="navbar-nav ml-auto align-items-center">
              <li className="nav-item text-nowrap">
                <span className="grey3">{ getStaffType() }:</span>  <span className="black fw-700">{ currentUser?.staff?.first_name } { currentUser?.staff?.last_name }</span>
                { (currentUser?.staff?.staff_type === 'partner' && currentUser?.staff?.country_code) && <span className="black">({ currentUser?.staff?.country_code })</span> }
              </li>
              <li className="nav-item active position-relative">
                <Link to={ generalRoutes.chat } className="nav-link p-0 position-relative chat-notification-wrapper">
                  <i className="ri-message-2-fill fz24" style={ { color: '#aeaeae' } }></i>
                  { totalUnreadMessageCount > 0 && (
                    <span
                      className="notification-badge"
                      style={ {
                        top: '-7px'
                      } }
                    >
                      { totalUnreadMessageCount > 10 ? '10+' : totalUnreadMessageCount }
                    </span>
                  ) }
                </Link>
              </li>
              <NotificationDropdown notificationUnreadCount={ notificationUnreadCount } />
              <NavItemLink
                to={ generalRoutes.myCalendar }
                icon={ isMyCalendarPage ? calendarBlue : greyCalendarHeader }
                alt="Calendar"
              />
              <React.Suspense fallback={ <div>{ translation('key_loading') }</div> }>
                <LanguageSwitcher />
              </React.Suspense>
              <UserProfileDropdown logOut={ logOut } />
            </ul>
          </div>
        </nav>
      </div>
    </div>
  );
}

TopBar.propTypes = {
  logOut: PropTypes.func.isRequired,
};
export default TopBar;